interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export default function ToggleSwitch({ checked, onChange, disabled = false }: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`
        relative inline-flex items-center shrink-0
        w-7 h-[15px] rounded-full
        transition-colors duration-200 ease-in-out
        focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500/50
        ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
        ${checked ? 'bg-cyan-500' : 'bg-white/[0.12]'}
      `}
    >
      <span
        className={`
          pointer-events-none inline-block
          w-[11px] h-[11px] rounded-full bg-white
          shadow-sm transform transition-transform duration-200 ease-in-out
          ${checked ? 'translate-x-[14px]' : 'translate-x-[2px]'}
        `}
      />
    </button>
  );
}
